// PageProjectViewOverview Component

import React from 'react'
import $ from 'jquery'
import _ from 'lodash'

import app from '../../../app.jsx'
import TimeUtil from '../../../lib/timeutil.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import eventfilters from '../../../lib/eventfilters.jsx'
import ProjectDashboardItem from '../../project/project_dashboarditem/project_dashboarditem.jsx'
import ProjectDashboardItemAdd from '../../project/project_dashboarditem_add/project_dashboarditem_add.jsx'
import BaseProjectView from '../../page/base_projectview/base_projectview.jsx'
import DashboardTaskList from '../../../common/dashboard/dashboard_tasklist/dashboard_tasklist.jsx'
import DialogSetting from '../../../contact/dialog/dialog_setting/dialog_setting.jsx'
import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'
import Button from '../../../common/common/button/button.jsx'
import TaskUtil from '../../../lib/taskutil.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import DialogTaskDetail from '../../../task/dialog/dialog_taskdetail/dialog_taskdetail.jsx'
import DialogTimeCardDetail from '../../../time/dialog/dialog_timecard_detail/dialog_timecard_detail.jsx'
import OverviewAddItem from '../../overview/overview_additem/overview_additem.jsx'
import ContentMessage from '../../../common/common/content_message/content_message.jsx'
import Acl from '../../../lib/acl.jsx'
import DialogEmailResend from '../../../common/dialog/dialog_email_resend/dialog_email_resend.jsx'
import InvoiceMailUtil from '../../../lib/invoicemailutil.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import ProfilerUtil from '../../../lib/profilerutil.jsx'
import Util from '../../../lib/util.jsx'
import routes from '../../../../shared/routes.js'
import timerStates from '../../../../shared/util/timer/timerStates.js'
import { buildTimerEvents } from '../../../../shared/util/timer/timerEvents.js'
import { ANALYTICS_EVENTS } from '../../../library/analytics/constants'
import { trackFileUpload } from '../../../theme/panel/panel_doc/utils'
import Alert from '../../../common/common/alert/alert'

class PageProjectViewOverview extends BaseProjectView {
  constructor (props) {
    super(props, 'projectview-overview', 'project', 'projectview-overview')

    this.data = {
      project: this._getProjectFromCache(this.props.projectId),
      stat: this._getOverviewStatFromCache(this.props.projectId),
      activityGroups: [],
      taskGroups: [],
      sort: 'title',
      sortAsc: true,
      users: [],
      projects: [],
      activeTask: null,
      pageState: {
        activityFilterType: 'all'
      },
      activeInvoicePersons: [],
      team: app.getTeam()
    }

    this.state = {
      bShowComment: false,
      taskInfo: null,
      profilerId: null
    }

    this._references = {
      dialogTaskDetail: React.createRef(),
      dialogTimeCardDetail: React.createRef(),
      refdialogMail: React.createRef(),
      overviewItemAdd: React.createRef(),
      taskSettingDialog: React.createRef(),
      confirmDelete: React.createRef(),
      alert: React.createRef()
    }
    this.createCommonReference(this._references)

    this.weekNo = DateUtil.getLocalWeekNo()
    this.showFabButton = true
    this._resizeHandler = this._resize.bind(this)
    this._setFABButtonState(true, true)

    /* Initialize profiler */
    this._profiler = new ProfilerUtil(this._pageIdent, 3) // Average time 3 seconds
    this._profiler.start()
    this._profiler.setParams(this.props.projectId)

    this._bUnMounted = false
  }

  componentDidMount () {
    $(window).on('resize', this._resizeHandler)
    app.updatePageTitle('project-view', 'Team')
    this._getData(false)
    this._updateColumnMaxHeight()
    this._initEvents()
    this._initProjectCommonEvents()

    // Calculate and save profiler, Hardcode profiler id as 1, since it is the first call of profiler
    this._profiler.stop(1)

    /* Load quickbook options for expense */
    this._initQuickbookItems()
  }

  componentWillUnmount () {
    this._releaseEvents()
    this._releaseProjectCommonEvents()
    $(window).off('resize', this._resizeHandler)

    this._profiler = null
    this._bUnMounted = true
  }

  componentDidUpdate (prevProps, prevState) {
    this._updateColumnMaxHeight()

    if (
      this._profiler &&
      (!prevState || prevState.profilerId !== this.state.profilerId) &&
      this.state.profilerId
    ) {
      this._profiler.stop(this.state.profilerId)
    }
  }

  renderContent () {
    const { stat, activityGroups } = this.data
    const pageInnerClass = 'pageinnercont'
    if (!stat) {
      return null
    }

    let totalActivities = 0
    activityGroups.map((group, _idx) => {
      totalActivities += group.activities.length
    })

    return (
      <div className={pageInnerClass}>
        <div className='overviewcont'>
          <div className='overviewcontwrap'>
            {Acl.isPlannerAllowed() && (
              <div className='contleft colcontent'>
                {this._renderTaskList()}
              </div>
            )}
            <div className='contright colcontent'>
              {totalActivities > 0 ||
                (this.state.bShowComment && <span className='hline' />)}
              {this.state.bShowComment && (
                <ProjectDashboardItemAdd
                  onDelete={this._onDeleteComment.bind(this)}
                  onChange={this._onCreateComment.bind(this)}
                />
              )}
              {this._renderActivityGroups(activityGroups)}
            </div>
          </div>
        </div>
        {this._renderSettingsDialog()}
        <DialogTaskDetail
          ref={this._references.dialogTaskDetail}
          onSubmit={this._onUpdateTaskDetail.bind(this)}
          onSearchActivity={this._onSearchActivity.bind(this)}
        />
        <DialogTimeCardDetail
          ref={this._references.dialogTimeCardDetail}
          projects={this.data.projects}
          getActivities={TimeUtil.onSearchActivity}
          getTasks={TimeUtil.onGetTasks}
          onUpdateDetail={this._onUpdateTimeCardDetail.bind(this, false)}
          onFinalize={this._onUpdateTimeCardDetail.bind(this, true)}
          onDelete={this._onDeleteTimeCardDetail.bind(this)}
        />
        <DialogEmailResend
          ref={this._references.refdialogMail}
          onSubmit={this._onSubmitMail.bind(this)}
          showWithoutContext={false}
          downloadBaseUrl={`/invoice/preview/${this.data.project.teamId}/${app.loggedInId}/`}
          showLanguage={app.teamCountry === 'NL' || app.teamCountry === 'DE'}
        />
        <OverviewAddItem
          ref={this._references.overviewItemAdd}
          onClose={this._onFABOverviewAddClose.bind(this)}
          onTaskAdd={this._onAddTask.bind(this)}
          onNoteAdd={this._onAddComment.bind(this)}
        />
        {this._renderExpenseForm()}
        <Alert ref={this._references.alert} />
      </div>
    )
  }

  getContentClassname () {
    return 'projectoverview full'
  }

  onFABClose () {
    if (this._references.overviewItemAdd.current) {
      this._references.overviewItemAdd.current.hide()
    }
  }

  /* Event handlers */
  _onFABOverviewAddClose () {
    this._hideCloseFABButton()
  }

  _onUpdateTimeCardDetail (bFinalaize, timeCardId, detailObj) {
    if (this._references.dialogTimeCardDetail.current) {
      this._references.dialogTimeCardDetail.current.hide()
    }

    const timer = this.getTimer()
    TimeUtil.updateTimeCardDetail(timeCardId, detailObj, timer, bFinalaize)
  }

  _onDeleteTimeCardDetail (timeCardId) {
    if (!timeCardId) {
      return false
    }

    // Remove timecard and remove timer
    this._removeTimerAndTimeCard(timeCardId, () => {
      if (this._references.dialogTimeCardDetail.current) {
        this._references.dialogTimeCardDetail.current.hide()
      }
    })
  }

  _onSubmitMail (mailObj) {
    app.debug('PageInvoice: _onSubmitMail [Start]')

    const emails = []
    const contactPersons = this.data.activeInvoicePersons
    if (contactPersons.length > 0) {
      contactPersons.map(contactPerson => {
        if (mailObj.toEmails && mailObj.toEmails.length > 0) {
          mailObj.toEmails.map(mail => {
            if (mail.text === contactPerson.key) {
              emails.push(contactPerson.email)
            }
          })
          _.remove(
            mailObj.toEmails,
            toEmail => toEmail.text === contactPerson.key
          )
        }
      })
    }

    mailObj.toEmails.map(mail => {
      emails.push(mail.text)
    })

    mailObj.toEmails = emails

    return InvoiceMailUtil.onSubmitMail(mailObj, res => {
      if (res) {
        this._updateInvoice(mailObj.id)
        if (this._references.refdialogMail.current) {
          this._references.refdialogMail.current.hide()
        }
      } else {
        app.debug('PageInvoice : _onSubmitMail err')
      }
    })
  }

  _updateInvoice (invoiceId) {
    const updateObj = { lastReminderDate: DateUtil.getUTCCurrentDate() }

    app
      .service('/api/invoice')
      .patch(invoiceId, updateObj)
      .then(_updateRes => {
        this._reloadData()
      })
      .catch(introErr => {
        app.debug('PageInvoice: _onUpdateInvoice err', introErr)
      })
  }

  _onAddComment (ev) {
    ev.preventDefault()

    this.onFABClose()
    this.setState({ bShowComment: true })
  }

  _onAddTask (ev) {
    ev.preventDefault()

    this.onFABClose()
    app.changePage(
      'task',
      null,
      { date: null, project: this.data.project },
      'addTask'
    )
  }

  _onCreateOrUpdateTask (task, bOpen, taskId, attachment, bFileDeleted) {
    if (taskId) {
      TaskUtil.updateTask(
        taskId,
        task,
        attachment,
        bFileDeleted,
        (updateRes, updateErr) => {
          if (!updateErr) {
            this.showFabButton = true
            this.onFABClose()
          } else {
            app.debug('PageProjectoverview: updateTask Error', updateErr)
          }
        }
      )
    } else {
      TaskUtil.createTask(
        task,
        attachment,
        bFileDeleted,
        (createRes, createErr) => {
          if (!createErr) {
            this.showFabButton = true
            this.onFABClose()
          } else {
            app.debug('PageProjectoverview: createTask Error', createErr)
          }
        }
      )
    }
  }

  _onSearchActivity (projectId, callback) {
    const extraQuery = {}
    const project = _.find(this.data.projects, obj => obj.value === projectId)

    if (project && project.activePhaseNos) {
      extraQuery.activePhaseNos = project.activePhaseNos
    }

    TaskUtil.searchActivity(projectId, extraQuery, callback)
  }

  _onClickActivityItem (activity) {
    if (activity.type === 'estimate') {
      app.changePage('estimate-view', activity.objectId)
    } else if (activity.type === 'invoice') {
      app.changePage('invoice-view', activity.objectId)
    } else if (activity.type === 'purchaseorder') {
      app.changePage('purchaseorder-view', activity.objectId)
    } else if (activity.type === 'expense') {
      this._onShowExpenseForm(activity.objectId)
    }
  }

  _onShowExpenseForm (expenseItemId) {
    const params = {
      query: {
        type: 'get-by-expenseitem',
        expenseItemId: expenseItemId
      }
    }

    return app
      .service('api/expense/detail')
      .find(params)
      .then(expenseRes => {
        if (
          expenseRes.expense &&
          expenseRes.expense.id &&
          expenseRes.expenseItems.length > 0
        ) {
          if (expenseRes.expenseItems) {
            expenseRes.expenseItems.map((item, _itemIdx) => {
              item.invoiceTotal = item.total
              item.selected = true
            })
          }

          if (this._references.expenseForm.current) {
            this._references.expenseForm.current.show(
              expenseRes.expense,
              true,
              expenseRes.expenseItems || []
            )
          }
        }
      })
  }

  _onDownloadActivityItem (activity) {
    if (activity.type === 'estimate') {
      const createObj = {
        estimateId: activity.objectId
      }
      this._generateEstimatePdf(createObj)
    } else if (activity.type === 'invoice') {
      const createObj = {
        invoiceId: activity.objectId
      }

      this._generateInvoicePdf(createObj)
    } else if (activity.type === 'purchaseorder') {
      const createObj = {
        purchaseOrderId: activity.objectId
      }

      this._generatePurchaseOrderPdf(createObj)
    } else if (activity.type === 'expense') {
      const createObj = {
        expenseId: activity.objectId,
        attachment: activity.attachment ? activity.attachment : null
      }

      this._getExpenseAttachment(createObj)
    }
  }

  _getActivityDownloadUrl (activity) {
    const teamId = app.getTeamId()

    if (activity.type === 'estimate') {
      const pdfFileName = Util.getPdfFileName(
        'estimate',
        activity.objectNo,
        activity.status
      )
      return `/estimate/preview/${app.getTeamId()}/${app.loggedInId}/${
        activity.objectId
      }/${pdfFileName}`
    } else if (activity.type === 'invoice') {
      const pdfFileName = Util.getPdfFileName(
        'invoice',
        activity.objectNo,
        activity.status
      )
      return `/invoice/preview/${app.getTeamId()}/${app.loggedInId}/${
        activity.objectId
      }/false/${pdfFileName}`
    } else if (activity.type === 'purchaseorder') {
      const pdfFileName = Util.getPdfFileName(
        'purchaseorder',
        activity.objectNo,
        activity.status
      )

      return `${routes.PURCHASEORDER_PREVIEW}/${app.getTeamId()}/${app.loggedInId}/${activity.objectId}/${pdfFileName}`
    } else if (activity.type === 'expense') {
      if (activity.attachment) {
        return `/expense/preview/${teamId}/${activity.attachment.fileName}/${activity.attachment.name}`
      }

      return ''
    }

    return ''
  }

  _getExpenseAttachment (createObj) {
    const teamId = app.getTeamId()
    const attachment = createObj.attachment
    if (attachment) {
      app.redirect(
        encodeURI(
          `/expense/download/${teamId}/${attachment.fileName}/${attachment.name}`
        )
      )
    }
  }

  _generatePurchaseOrderPdf (createObj) {
    const teamId = app.getTeamId()
    app
      .service('/api/purchaseorder/pdf')
      .create(createObj, {})
      .then(pdfRes => {
        app.redirect(
          encodeURI(`/purchaseorder/download/${teamId}/${pdfRes.pdfName}`)
        )
      })
      .catch(pdfErr => {
        app.debug('projectoverview purchaseorder: _onClickDownload', pdfErr)
      })
  }

  _generateInvoicePdf (createObj) {
    const teamId = app.getTeamId()
    app
      .service('/api/invoice/pdf')
      .create(createObj, {})
      .then(pdfRes => {
        app.redirect(encodeURI(`/invoice/download/${teamId}/${pdfRes.pdfName}`))
      })
      .catch(pdfErr => {
        app.debug('projectoverview invoice: _onClickDownload', pdfErr)
      })
  }

  _generateEstimatePdf (createObj) {
    const teamId = app.getTeamId()
    app
      .service('/api/estimate/pdf')
      .create(createObj, {})
      .then(pdfRes => {
        app.redirect(
          encodeURI(`/estimate/download/${teamId}/${pdfRes.pdfName}`)
        )
      })
      .catch(pdfErr => {
        app.debug('projectoverview estimate: _onDownload', pdfErr)
      })
  }

  _resize () {
    window.setTimeout(this._updateColumnMaxHeight.bind(this), 500)
  }

  _updateColumnMaxHeight () {
    const cols = $(
      '.projectoverview .pageinnercont > .overviewcont > .colcontent'
    )
    cols.css('height', 'auto')
    let maxHeight = 0

    for (let i = 1; i <= cols.length; i++) {
      const height = cols.eq(i - 1).outerHeight()
      if (height > maxHeight) {
        maxHeight = height
      }
    }

    if (maxHeight > 0) {
      const contOuterHeight = $('.projectoverview .baser-projectviewheader')
        .eq(0)
        .outerHeight()
      const minHeight = $(window).height() - contOuterHeight

      if (maxHeight < minHeight) {
        maxHeight = minHeight
      }
      cols.css('height', `${maxHeight}px`)
    }
  }

  onAdd () {
    if (this._references.overviewItemAdd.current) {
      this._references.overviewItemAdd.current.show()
    }
  }

  _onDeleteComment (ev) {
    ev.preventDefault()
    this.setState({ bShowComment: false })
  }

  _onCreateComment (value) {
    if (!value) return

    const activityObj = {
      userId: app.loggedInId,
      projectId: this.props.projectId,
      activityDate: DateUtil.getUTCCurrentDate(),
      type: 'comment',
      comments: value,
      objectId: null,
      title: null,
      subtitle: null
    }

    app
      .service('/api/project/activity')
      .create(activityObj)
      .then(_createRes => {
        this._reloadData()
        this.setState({ bShowComment: false })
        this.onFABClose()
      })
      .catch(err => {
        app.debug(
          '### PageProjectViewOverview - _onCreateComment - Error ',
          err
        )
      })
  }

  _onUpdateComment (activity, value) {
    const updateObj = {
      commentAttachments: activity.commentAttachments,
      comments: value
    }

    app
      .service('/api/project/activity')
      .patch(activity.id, updateObj)
      .then(_createRes => {
        this._reloadData()
      })
      .catch(err => {
        app.debug(
          '### PageProjectViewOverview - _onCreateComment - Error ',
          err
        )
      })
  }

  handleAddAttachmentToComment = (file, message, activity) => {
    const fileObj = { fileName: message.id, fileDisplayName: file.name }
    const uploadData = {
      commentAttachments: [...activity.commentAttachments || [], fileObj]
    }

    app
      .service('/api/project/activity')
      .patch(activity.id, uploadData)
      .then(() => {
        this._reloadData()
        trackFileUpload(file, ANALYTICS_EVENTS.projectFileUpload)
      })
      .catch(err => {
        this.showToastError('common.error.uploadFile')
        app.debug(
          '### PageProjectViewOverview - handleAddAttachmentToComment - Error ',
          err
        )
      })
  }

  handleDeleteAttachmentFromComment = (activity, index) => {
    const commentAttachmentsCopy = [...activity.commentAttachments]
    const fileToBeDeleted = activity.commentAttachments[index]
    commentAttachmentsCopy.splice(index, 1) // remove specific item from the array

    const updatedData = {
      activityId: activity.id,
      commentAttachments: commentAttachmentsCopy,
      userId: app.loggedInId,
      fileToBeDeleted
    }

    app
      .service('/api/project/activity-comment-attachment')
      .remove(updatedData)
      .then(this._reloadData)
      .catch(err => {
        this.showToastError('common.error.deleteFile')
        app.debug(
          '### PageProjectViewOverview - handleDeleteAttachmentFromComment - Error ',
          err
        )
      })
  }

  _onDeleteActivity (activity) {
    if (!activity.id) {
      return false
    }

    app
      .service('/api/project/activity')
      .remove(activity.id)
      .then(_createRes => {
        this._reloadData()
      })
      .catch(err => {
        app.debug(
          '### PageProjectViewOverview - _onCreateComment - Error ',
          err
        )
      })
  }

  _onChangeDate (value, callback) {
    if (value) {
      TaskUtil.getDateSchedule(app.loggedInId, value, callback)
    }
  }

  _onCloseTaskAdd () {
    this._setFABButtonVisible(true)
    this.setState({ dataDate: new Date() })
  }

  showToastError (msgIdent) {
    if (this._references.alert.current) {
      this._references.alert.current.onShow(
        IntlUtil.convertMessage(msgIdent),
        'error'
      )
    }
  }

  /* Private function */
  _renderSettingsDialog () {
    const { taskInfo, loading } = this.state
    if (loading) {
      return ''
    }

    let task = null
    let bDisable = false
    let tooltipDelete = null
    let tooltipEdit = null

    if (taskInfo) {
      task = taskInfo.task
      bDisable = !taskInfo.canEdit

      if (taskInfo.isPhaseClosed) {
        tooltipDelete = 'common.dashboard.tipDisableDeleteTextProjectClosed'
        tooltipEdit = 'common.dashboard.tipDisableEditTextProjectClosed'
      } else if (!taskInfo.canEdit) {
        tooltipDelete = 'common.dashboard.tipDisableDeleteText'
        tooltipEdit = 'common.dashboard.tipDisableEditText'
      }
    }

    const colClass = 'actionboard-col2 alert-col2'
    const _actionBtnClass = `action-btn${bDisable ? ' disable' : ''}`
    const _buttonDeleteClass = `button_dialog button_dialogdlt button_dialogdlt ${
      bDisable ? ' disabled' : ''
    }`
    const _buttonEditClass = `button_dialog button_dialogedit ${
      bDisable ? ' disabled' : ''
    }`

    return (
      <DialogSetting
        ref={this._references.taskSettingDialog}
        onClose={this._onCloseSetting.bind(this)}
      >
        <div className='actionboard-row act-row'>
          <div className={colClass}>
            <div
              className={_actionBtnClass}
              onClick={!bDisable ? this._onDelete.bind(this) : null}
            >
              <Button
                icon='action-delete'
                className={_buttonDeleteClass}
                canHover={false}
                tooltip={tooltipDelete}
                tooltipPosition='top'
              />
              <span className='label'>
                <IntlMessage ident='common.dashboard.actionDelete' />
              </span>
            </div>
          </div>
          <div className={colClass}>
            <div
              className={_actionBtnClass}
              onClick={!bDisable ? this._onEdit.bind(this, task) : null}
            >
              <Button
                icon='action-edit'
                className={_buttonEditClass}
                canHover={false}
                tooltip={tooltipEdit}
                tooltipPosition='top'
              />
              <span className='label'>
                <IntlMessage ident='common.dashboard.actionEdit' />
              </span>
            </div>
          </div>
        </div>
        {task && task.file && (
          <div className='actionboard-row act-row'>
            <div className='actionboard-col2 alert-col2'>
              <a
                className='action-btn'
                target='_blank'
                rel='noopener noreferrer'
                href={encodeURI(
                  `/task/preview/${app.getTeamId()}/${task.file.fileName}`
                )}
              >
                <Button
                  icon='action-attachment'
                  className='button_dialog'
                  canHover={false}
                />
                <span className='label'>
                  <IntlMessage ident='task.list.actionOpenAttachment' />
                </span>
              </a>
            </div>
          </div>
        )}
        <ConfirmDelete
          ref={this._references.confirmDelete}
          title='common.dashboard.msgConfirmDelete'
          onClickOk={this._onClickDeleteConfirm.bind(this)}
        />
      </DialogSetting>
    )
  }

  _onCloseSetting () {
    if (this._references.confirmDelete.current) {
      this._references.confirmDelete.current.hide()
    }
  }

  _onEdit (task, e) {
    e.preventDefault()

    if (task && task.id) {
      if (this._references.taskSettingDialog.current) {
        this._references.taskSettingDialog.current.hide()
      }

      app.changePage('task', task.id, {
        date: task.nearestScheduleDate,
        project: null
      })
    }
  }

  _onDelete (e) {
    e.preventDefault()
    if (this._references.confirmDelete.current) {
      this._references.confirmDelete.current.show()
    }
  }

  _onClickDeleteConfirm (e) {
    e.preventDefault()
    TaskUtil.removeTask(this.state.taskInfo.task.id, (deleteRes, deleteErr) => {
      if (!deleteErr) {
        if (this._references.taskSettingDialog.current) {
          this._references.taskSettingDialog.current.hide()
        }
      } else {
        app.debug('PageTime: _onClickDeleteConfirm Error', deleteErr)
      }
    })
  }

  _getData (bReload) {
    // Start profiler
    const profilerId = this._profiler ? this._profiler.start() : 0

    const currDate = new Date()
    const params = {
      query: {
        bUpdatePageState: bReload,
        pageState: this.data.pageState,
        pageIdent: this._pageIdent,
        projectId: this.props.projectId,
        project: {
          $client: {
            subObjects: {
              contact: ['company', 'rateCards', 'rateMarkup', 'rate']
            }
          }
        },
        overview: {
          weekNo: this.weekNo,
          userId: app.loggedInId,
          activeDate: new Date(
            currDate.getFullYear(),
            currDate.getMonth(),
            currDate.getDate()
          )
        },
        userTeam: {
          teamId: app.getTeamId(),
          $select: ['userId', 'firstName', 'lastName'],
          status: 'active'
        }
      }
    }

    app
      .service('/api/page/project/overview')
      .find(params)
      .then(result => {
        if (result) {
          this._onPageDataRecieved(result.pageData)

          if (result.project) {
            this.data.project = result.project
            this._setProjectToCache(this.data.project)
          }
          if (result.tags) {
            this._tagSuggestions = result.tags
          }
          if (result.overview) {
            this.data.stat = result.overview.stat
            this._setOverviewStatToCache(this.data.stat)

            this.data.activityGroups = result.overview.activityGroups

            if (result.project.status === 'closed') {
              this.data.taskGroups = []
            } else {
              this.data.taskGroups = result.overview.tasks
            }
          }
          if (result.users) {
            this.data.users = result.users
          }
          if (result.projectOptions) {
            this.data.projects = result.projectOptions
          }
        }
        this._onDataReceived(null, profilerId)
      })
      .catch(err => {
        this._onDataReceived(err, profilerId)
      })
  }

  _reloadData = () => {
    this._getData(true)
  }

  _onDataReceived (err, profilerId) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PageProjectViewOverview: _onDataReceived Error', err)
      this._setFABButtonVisible(false)
      this.setState({
        loading: true,
        dataDate: new Date(),
        profilerId: profilerId
      })
    } else {
      app.debug('PageProjectViewOverview: _onDataReceived [done]')
      this._setFABButtonVisible(true)
      this.showFabButton = true

      this.setState({
        loading: !this.data.project,
        dataDate: new Date(),
        profilerId: profilerId
      })

      app.updatePageTitle(
        'projectview-team',
        this.data.project ? this.data.project.title : ''
      )
    }
  }

  _onUserStateRecieved (userState) {
    const pageState = this._getPageUserState(userState)
    if (pageState) {
      this.data.pageState = {
        activityFilterType: pageState.activityFilterType || 'all'
      }
    }
  }

  _renderActivityGroups (activityGroups) {
    let totalCount = 0

    const items = activityGroups.map((group, idx) => {
      let groupActivities = _.cloneDeep(group.activities)
      if (this.data.pageState.activityFilterType !== 'all') {
        groupActivities = _.filter(
          groupActivities,
          obj => obj.type === this.data.pageState.activityFilterType
        )
      }

      if (groupActivities.length <= 0) return null

      totalCount += groupActivities.length
      let label = ''
      if (group.type === 'pinned') {
        label = 'project.view.labelPinned'
      } else if (group.type === 'today') {
        label = 'project.view.labelToday'
      } else if (group.type === 'this-week') {
        label = 'project.view.labelThisWeek'
      } else if (group.type === 'last-week') {
        label = 'project.view.labelLastWeek'
      } else if (group.type === 'earlier') {
        label = 'project.view.labelEarlier'
      }

      return (
        <div className='activitygroup' key={idx}>
          <div className='listheader'>
            <span className='title'>{IntlUtil.convertMessage(label)}</span>
          </div>
          <div className='projectlist'>
            {this._renderActivities(groupActivities, group.type)}
          </div>
        </div>
      )
    })

    if (totalCount === 0) {
      return (
        <ContentMessage
          message='project.view.msgErrorTitle'
          info='project.view.msgErrorContent'
        />
      )
    }
    return items
  }

  _renderActivities (activities, type) {
    return activities.map((activity, _idx) => {
      const bPinned = type === 'pinned'
      let bShowDownload = !!(
        activity.type === 'estimate' ||
        activity.type === 'invoice' ||
        activity.type === 'purchaseorder'
      )
      if (activity.type === 'expense' && activity.attachment) {
        bShowDownload = true
      }

      return (
        <ProjectDashboardItem
          key={activity.id}
          activity={activity}
          pinned={bPinned}
          onClick={
            !activity.deleted ? this._onClickActivityItem.bind(this) : null
          }
          onUpdateComment={this._onUpdateComment.bind(this)}
          onDelete={this._onDeleteActivity.bind(this)}
          downloadUrl={this._getActivityDownloadUrl(activity)}
          onClickPin={this._onClickPin.bind(this)}
          showdownload={bShowDownload}
          onResendMail={this._onResendMail.bind(this)}
          bShowReminder={!!Acl.isFullUser()}
          onAddAttachmentToComment={(file, message) => this.handleAddAttachmentToComment(file, message, activity)}
          onDeleteAttachmentFromComment={(fileName) => this.handleDeleteAttachmentFromComment(activity, fileName)}
        />
      )
    })
  }

  _onResendMail (invoice) {
    const invoiceId = invoice.objectId
    const params = { query: { bResend: true } }
    app
      .service('/api/invoice/mail')
      .get(invoiceId, params)
      .then(result => {
        if (result) {
          this.data.activeInvoicePersons = result.contactPersons
          if (this._references.refdialogMail.current) {
            this._references.refdialogMail.current.show(
              result,
              invoiceId,
              invoice
            )
          }
        }
      })
      .catch(err => {
        app.debug('PageInvoice: _showEmailDialog err', err)
      })
  }

  _onClickDownload (invoice) {
    const teamId = app.getTeamId()
    if (invoice) {
      const createObj = {
        invoiceId: invoice.id
      }

      app
        .service('/api/invoice/pdf')
        .create(createObj, {})
        .then(pdfRes => {
          app.redirect(
            encodeURI(`/invoice/download/${teamId}/${pdfRes.pdfName}`)
          )
        })
        .catch(pdfErr => {
          app.debug('PageInvoice: _onClickDownload', pdfErr)
        })
    }
  }

  _onClickPin (activity, bPinned) {
    const activityObj = {
      userId: app.loggedInId,
      projectId: this.props.projectId,
      activityId: activity.id,
      teamId: app.getTeamId()
    }

    if (!bPinned) {
      app
        .service('/api/user/projectactivity')
        .create(activityObj)
        .then(_createRes => {
          this._reloadData()
        })
        .catch(err => {
          app.debug(
            '### PageProjectViewOverview - _onCreatePinned - Error ',
            err
          )
        })
    } else {
      const params = {
        query: {
          userId: app.loggedInId,
          projectId: this.props.projectId,
          activityId: activity.id
        }
      }

      app
        .service('/api/user/projectactivity')
        .remove(null, params)
        .then(_deleteRes => {
          this._reloadData()
        })
        .catch(err => {
          app.debug(
            '### PageProjectViewOverview - _onDeletePinned - Error ',
            err
          )
        })
    }
  }

  _onItemSettingClick (taskInfo) {
    if (taskInfo) {
      this.setState({ taskInfo: taskInfo })
      if (this._references.taskSettingDialog.current) {
        this._references.taskSettingDialog.current.show(
          taskInfo.task.title,
          null,
          null,
          null
        )
      }
    }
  }

  _onAddTime (task) {
    if (task.userId) {
      const timeCard = TaskUtil.getTimecardDataFromTask(task)
      TimeUtil.createTimeCard(timeCard, createRes => {
        app.changePage('time', 'showTimeCard', createRes.id, {
          userId: createRes.userId,
          date: null
        })
      })
    }
  }

  _renderTaskList () {
    let totalCount = 0
    this.data.taskGroups.map((group, _idx) => {
      totalCount += group.tasks.length
    })

    const timer = this._getTimer()
    if (totalCount > 0) {
      return (
        <DashboardTaskList
          taskGroups={this.data.taskGroups}
          timer={timer}
          loggedInUserId={app.loggedInId}
          showTimecardAdd
          stopAndCreateNewTimeCard={this._stopAndCreateNewTimeCard.bind(this)}
          onStart={this._onStart.bind(this)}
          onStop={this._onStop.bind(this)}
          onPause={this._onPause.bind(this)}
          onResume={this._onResume.bind(this)}
          onCompleteTask={this._onCompleteTask.bind(this)}
          onUpdateSubTasks={this._onUpdateSubTasks.bind(this)}
          sortOptions={this._getSortOptions()}
          onSort={this._onSort.bind(this)}
          sort={this.data.sort}
          sortAsc={this.data.sortAsc}
          onClickTaskSetting={this._onItemSettingClick.bind(this)}
          onAddTime={this._onAddTime.bind(this)}
        />
      )
    }

    if (totalCount === 0) {
      const bAddButton = this.data.project.status !== 'closed'
      const contentInfo = bAddButton ? 'project.view.msgTaskErrorContent' : ''

      return (
        <ContentMessage
          message='project.view.msgTaskErrorTitle'
          info={contentInfo}
          showAddPrefix={bAddButton}
          showAdd={bAddButton}
          onAdd={this._onAddTask.bind(this)}
        />
      )
    }
  }

  _onStart (task) {
    const timer = this._getTimer()
    if (timer.exists && !timer.ProjectId()) {
      // Pause the timer immediately once the stop button is pressed
      timer.pause(app)

      app
        .service('/api/timecard')
        .get(timer.TimeCardId(), {})
        .then(result => {
          if (result) {
            const timecard = result
            if (this._references.dialogTimeCardDetail.current) {
              this._references.dialogTimeCardDetail.current.show(
                timecard,
                true,
                false,
                !timer.TaskId()
              )
            }
            this.data.activeTask = task
          }
        })
        .catch(err => {
          app.debug('PageTime: _getDataTimeCardStat err', err)
        })
    } else {
      this._createOrUpdateTask(task)
    }
  }

  _createOrUpdateTask (task) {
    const timer = this._getTimer()
    const timerEvents = buildTimerEvents(app)
    if (timer.doesRelateToTaskId(task.id)) {
      timer.resume(app)
    } else {
      const createObj = {
        userId: app.loggedInId,
        projectId: task.projectId,
        activityId: task.activityId,
        taskId: task.id,
        timeCardId: null,
        status: timerStates.STARTED
      }

      timerEvents.createTimer(createObj)
    }
  }

  _onPause (_task) {
    const timer = this._getTimer()
    timer.pause(app)
  }

  _onResume (_task) {
    const timer = this._getTimer()
    timer.resume(app)
  }

  _onStop (_task) {
    const timer = this._getTimer()
    timer.stop(app)
  }

  _onCompleteTask (task, nonTrackedMinutes) {
    if (!task.id) {
      return
    }

    if (task.projectId && task.activityId) {
      app
        .service('/api/project/plannertask')
        .patch(task.id, { completed: task.completed }, {})
        .then(_result => {
          if (task.completed && task.userId) {
            this._createTimercardForCompletedTask(task, nonTrackedMinutes)
          } else {
            this.forceUpdate()
          }
        })
        .catch(err => {
          app.debug('PageProjectOverview: _onCompleteTask err', err)
        })
    } else {
      if (this._references.dialogTaskDetail.current) {
        this._references.dialogTaskDetail.current.show(
          task,
          nonTrackedMinutes,
          this.data.projects
        )
      }
    }
  }

  _createTimercardForCompletedTask (task, nonTrackedMinutes) {
    const timeCard = TaskUtil.getTimecardDataFromTask(task)
    timeCard.timeTaken = nonTrackedMinutes
    if (nonTrackedMinutes <= 0) {
      return ''
    } else {
      TimeUtil.createTimeCard(timeCard, createRes => {
        app.changePage('time', 'showTimeCard', createRes.id, {
          userId: createRes.userId,
          date: null
        })
      })
    }
  }

  _onUpdateTaskDetail (task, nonTrackedMinutes) {
    if (!task.id) {
      return
    }

    const updateObj = {
      completed: task.completed,
      projectId: task.projectId,
      activityId: task.activityId
    }

    app
      .service('/api/project/plannertask')
      .patch(task.id, updateObj, {})
      .then(_result => {
        this._createTimercardForCompletedTask(task, nonTrackedMinutes)
      })
      .catch(err => {
        app.debug('PageDashboard: _onUpdateTaskDetail err', err)
      })
  }

  _onUpdateSubTasks (taskId, subtasks) {
    if (!taskId) {
      return
    }

    const updateObj = { subtasks: subtasks, noSubTasks: subtasks.length }
    app
      .service('/api/project/plannertask')
      .patch(taskId, updateObj, {})
      .then(_result => {
        this.forceUpdate()
      })
      .catch(err => {
        app.debug('PageProjectOverview: _onUpdateSubTasks err', err)
      })
  }

  _onSort (sort, sortAsc) {
    this.data.sort = sort
    this.data.sortAsc = sortAsc
    this._reloadData()
  }

  _getSortOptions () {
    return [
      { label: 'common.dashboard.orderByDateAsc', value: 'dateasc' },
      { label: 'common.dashboard.orderByDateDesc', value: 'datedesc' }
    ]
  }

  _onChangeFilter (filter) {
    if (filter) {
      this.data.pageState.activityFilterType = filter.activityFilterType
    }

    this.setState({ dataDate: new Date() })
  }

  /* Realtime Events */
  _initEvents () {
    this._initTimerEvents(this._onReloadTimer.bind(this))

    this._eventHandlers.projectActivityCreated = this._eventReload.bind(
      this,
      'Project Activity',
      'Created'
    )
    this._eventHandlers.projectActivityUpdated = this._eventReload.bind(
      this,
      'Project Activity',
      'Updated'
    )
    this._eventHandlers.projectActivityRemoved = this._eventReload.bind(
      this,
      'Project Activity',
      'Removed'
    )
    this._eventHandlers.projectActivityPatched = this._eventReload.bind(
      this,
      'Project Activity',
      'Patched'
    )
    this._eventHandlers.projectPatched = this._eventReload.bind(
      this,
      'Project',
      'Updated'
    )
    this._eventHandlers.projectUpdated = this._eventReload.bind(
      this,
      'Project',
      'Patched'
    )
    this._eventHandlers.invocieUpdated = this._eventReloadInvoice.bind(
      this,
      'Invoice',
      'Updated'
    )
    this._eventHandlers.invoicePatched = this._eventReloadInvoice.bind(
      this,
      'Invoice',
      'Patched'
    )
    this._eventHandlers.taskCreated = this._eventReload.bind(
      this,
      'Task',
      'Created'
    )
    this._eventHandlers.taskUpdated = this._eventReload.bind(
      this,
      'Task',
      'Updated'
    )
    this._eventHandlers.taskRemoved = this._eventReload.bind(
      this,
      'Task',
      'Removed'
    )
    this._eventHandlers.taskPatched = this._eventReload.bind(
      this,
      'Task',
      'Patched'
    )

    const projectActivityService = app.service('/api/project/activity')
    projectActivityService.on(
      'created',
      this._eventHandlers.projectActivityCreated
    )
    projectActivityService.on(
      'updated',
      this._eventHandlers.projectActivityUpdated
    )
    projectActivityService.on(
      'removed',
      this._eventHandlers.projectActivityRemoved
    )
    projectActivityService.on(
      'patched',
      this._eventHandlers.projectActivityPatched
    )

    const projectService = app.service('/api/project')
    projectService.on('updated', this._eventHandlers.projectUpdated)
    projectService.on('patched', this._eventHandlers.projectPatched)

    const invoiceService = app.service('/api/invoice')
    invoiceService.on('updated', this._eventHandlers.invocieUpdated)
    invoiceService.on('patched', this._eventHandlers.invoicePatched)

    const taskService = app.service('/api/project/plannertask')
    taskService.on('created', this._eventHandlers.taskCreated)
    taskService.on('updated', this._eventHandlers.taskUpdated)
    taskService.on('removed', this._eventHandlers.taskRemoved)
    taskService.on('patched', this._eventHandlers.taskPatched)
  }

  _releaseEvents () {
    this._releaseTimerEvents()

    // Activity Events
    const projectActivityService = app.service('/api/project/activity')
    projectActivityService.off(
      'created',
      this._eventHandlers.projectActivityCreated
    )
    projectActivityService.off(
      'updated',
      this._eventHandlers.projectActivityUpdated
    )
    projectActivityService.off(
      'removed',
      this._eventHandlers.projectActivityRemoved
    )
    projectActivityService.off(
      'patched',
      this._eventHandlers.projectActivityPatched
    )

    const projectService = app.service('/api/project')
    projectService.off('updated', this._eventHandlers.projectUpdated)
    projectService.off('patched', this._eventHandlers.projectPatched)

    const invoiceService = app.service('/api/invoice')
    invoiceService.off('updated', this._eventHandlers.invocieUpdated)
    invoiceService.off('patched', this._eventHandlers.invoicePatched)

    const taskService = app.service('/api/project/plannertask')
    taskService.off('created', this._eventHandlers.taskCreated)
    taskService.off('updated', this._eventHandlers.taskUpdated)
    taskService.off('removed', this._eventHandlers.taskRemoved)
    taskService.off('patched', this._eventHandlers.taskPatched)

    this._eventHandlers.projectActivityService = null
    this._eventHandlers.projectActivityService = null
    this._eventHandlers.projectActivityService = null
    this._eventHandlers.projectActivityService = null
    this._eventHandlers.projectPatched = null
    this._eventHandlers.projectUpdated = null
    this._eventHandlers.invocieUpdated = null
    this._eventHandlers.invoicePatched = null
    this._eventHandlers.taskCreated = null
    this._eventHandlers.taskUpdated = null
    this._eventHandlers.taskRemoved = null
    this._eventHandlers.taskPatched = null
  }

  _onReloadTimer (eventData) {
    if (eventfilters.teamFilter(eventData)) {
      this._reloadData()

      if (this.data.activeTask) {
        this._createOrUpdateTask(this.data.activeTask)
        this.data.activeTask = null
      }
    }
  }

  _eventReload (objectName, eventName, eventData) {
    if (eventfilters.teamFilter(eventData)) {
      app.debug(
        `-- Event - PageProjectOverview - ${objectName} - ${eventName} --`
      )
      this._reloadData()
    }
  }

  _eventReloadInvoice (objectName, eventName, eventData) {
    if (eventfilters.teamFilter(eventData)) {
      app.debug(
        `-- Event - PageProjectOverview - ${objectName} - ${eventName} --`
      )
      this._reloadData(['status', 'projectId'])
    }
  }

  _onAfterSaveExpense () {
    if (this._references.expenseForm.current) {
      this._references.expenseForm.current.hide()
    }
    this._reloadData()
  }

  /* Header Functions - Start */
  _onHeaderContentFilter (option) {
    this.data.pageState.activityFilterType = option.ident
    this.setState({ dataDate: new Date() })
  }
  /* Header Functions - End */
}

export default PageProjectViewOverview
